<script setup>
import SmallTitle from '@/components/elementos/SmallTitle/SmallTitle.vue';
import { computed, watch, ref, onUpdated } from 'vue';

const props = defineProps({
    modelValue: {
        type: Object,
        default: null
    },
    options: {
        type: Array,
        required: true
    },
    error: {
        type: String,
        default: null
    },
    label: {
        type: String,
        default: 'Detalhamento'
    },
    required: {
        type: Boolean,
        default: true
    },
    placeholder: {
        type: String,
        default: 'Selecione o detalhamento da rubrica'
    },
    loading: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue', 'change']);

const detalhamentoSelecionado = ref(null);

// Observar mudanças no modelValue para sincronizar (útil na edição)
watch(() => props.modelValue, (newValue) => {
    if (newValue && newValue !== detalhamentoSelecionado.value) {
        detalhamentoSelecionado.value = newValue;
    }
});

const handleChange = () => {
    emit('update:modelValue', detalhamentoSelecionado.value);
    emit('change', detalhamentoSelecionado.value);
};

onUpdated(() => {
    if(props.modelValue===null){
        detalhamentoSelecionado.value = null;
    } else if (props.modelValue && props.modelValue !== detalhamentoSelecionado.value) {
        detalhamentoSelecionado.value = props.modelValue;
    }
});
</script>

<template>
    <div class="field mb-2 col-12">
        <SmallTitle :titulo="label" :obrigatorio="required" />

        <Dropdown
            inputId="detalhamento_input"
            v-model="detalhamentoSelecionado"
            :options="options"
            optionLabel="descricao"
            :placeholder="placeholder"
            emptyFilterMessage="Nenhum item encontrado"
            class="text-sm"
            :class="{ 'p-invalid': error }"
            :loading="loading"
            :disabled="loading"
            @change="handleChange"
            :pt="{
                emptyFilterMessage: { class: 'text-sm' },
            }">
            <template #value="slotProps">
                <div v-if="slotProps.value" class="flex align-items-center">
                    <div class="text-sm" style="max-width: 200px;">
                        {{ slotProps.value.descricao }}
                    </div>
                </div>
                <span v-else>
                    <div class="text-sm">
                        {{ slotProps.placeholder }}
                    </div>
                </span>
            </template>
            <template #option="slotProps">
                <div style="max-width: 20rem;" class="flex align-items-center w-full text-sm">
                    <p class="text-sm m-0 white-space-normal">
                        {{ slotProps.option.descricao }}
                    </p>
                </div>
            </template>
        </Dropdown>
        
        <SmallError :error="error"/>
    </div>
</template>
